var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94715 12.4715L12.4158 6.34705C13.491 5.32904 13.4079 3.52696 12.2324 2.37139C11.0846 1.24303 9.33406 1.1655 8.3223 2.1982L2.03002 8.62075C2.03002 8.62075 3.4239 9.17531 4.40347 10.1383C5.38303 11.1012 5.94715 12.4715 5.94715 12.4715Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94715 12.4715L12.4158 6.34705C13.491 5.32904 13.4079 3.52696 12.2324 2.37139C11.0846 1.24303 9.33406 1.1655 8.3223 2.1982L2.03002 8.62075C2.03002 8.62075 3.4239 9.17531 4.40347 10.1383C5.38303 11.1012 5.94715 12.4715 5.94715 12.4715Z",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4195 13.3835L5.94356 12.4764C5.94356 12.4764 5.38071 11.1057 4.40203 10.1418C3.42335 9.17797 2.02998 8.62216 2.02998 8.62216L1.10746 12.0601C0.905009 12.8145 1.66231 13.5784 2.4195 13.3835Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4195 13.3835L5.94356 12.4764C5.94356 12.4764 5.38071 11.1057 4.40203 10.1418C3.42335 9.17797 2.02998 8.62216 2.02998 8.62216L1.10746 12.0601C0.905009 12.8145 1.66231 13.5784 2.4195 13.3835Z",
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.9014fe6eac9eb3c2d81dd611fdc18eed.svg";
export { ForwardRef as ReactComponent };